/*--------------------------------------------------------------------------
  For the mobile menu. DH 
/*------------------------------------------------------------------------*/
$(document).ready(function(){

//Probably need to reset some of these when the window is resized..
var menuWidth = jQuery('#offcanvas').width();
var menuHeight = jQuery('#offcanvas ul').outerHeight(true);
var navHeight = jQuery('.navigation_container').height();  

var docWidth = jQuery(document).width();  
var docHeight = jQuery(document).height();  

jQuery.fx.speeds._default = 300; // Global Animation Speed


  //Listening for click.
  jQuery('#mobile-toggle').on('click', function(direction) {
  
   //alert('Run Ma Plugin Bitch!');
  
    var myClass = jQuery(this).attr("class");
    ToggleMenu(myClass); //Calling ToogleMenu function with the class name.
  });

  function ToggleMenu(direction) {
    
    MenuPosition(direction); //Call Menu Position with the direction variable.
    
    if (jQuery('#offcanvas').hasClass("hidden")) {
        OpenMenu(direction);

        jQuery('#offcanvas').removeClass('hidden').css('left','');
        //console.log('IS VISIBLE');
      }   
      else {  
        CloseMenu(direction);
      jQuery('#offcanvas, .navigation_container, .wrapper').addClass('hidden').css({       //reset all the animation properties
        'transform': '',
        '-webkit-transform': '',
        'top': '',
        'left': '',
        'height': ''
      });
      }
	}
    
  function MenuPosition(direction) {
    if(direction == 'right') {
      jQuery('#offcanvas').css('left', docWidth); //Set the #offcanvas div to the left side.
      console.log('Moving #offcanvas left.');
    } else if(direction == 'top') {
      
    } else if(direction == 'bottom') {
      
    }
  }
  
  function CloseMenu(direction) {
  
    console.log('Running CloseMenu(' + direction + ')');
      
    jQuery('body').css({ //Set overflow y auto, set overflow x hidden.
      'overflow-y':'auto'},
      {'overflow-x':'hidden'
    });
      
    if (direction == 'left') {
    
      jQuery('#offcanvas').transition({ //Move #offcanvas left (Animate menu).
        x: '250px', 
      }, function() {
        console.log('#offcanvas set to x axis: 250px');
      });
        
      jQuery(".navigation_container, .wrapper").transition({
        x: '0px'
      }, function() {
        console.log('#page, #nav moved to x:0');
      });
        
    } else if(direction == 'right') {
      
      jQuery('#offcanvas').transition({ //Move #offcanvas left to width of document (Animate menu).
        x: docWidth
      }, function() {
        console.log('#offcanvas set to x axis: '+ docWidth);
      });
        
      jQuery(".navigation_container, .wrapper").transition({
        x: '0'
      }, function() {
        console.log('.wrapper, .navigation_container moved to x:0');
      });
        
    } else if(direction == 'top') {
      
      jQuery('#offcanvas').transition({
        y: '-=' + menuHeight
      }, function() {
        console.log('#offcanvas moved relatively y-: '+ menuHeight);
      });

      jQuery(".navigation_container, .wrapper").transition({
        y: '0'
      }, function() {
        console.log('.wrapper, .navigation_container moved to x:0');
      });
      
    } else if(direction == 'bottom') {
    
      jQuery('#offcanvas').css('bottom', '0px')
      jQuery('#offcanvas').animate({bottom: '-200px'});
      //jQuery('#offcanvas').transition({y: '+=' + menuHeight });
    }

  }
  
  
  function OpenMenu(direction) {
    
    console.log('Running OpenMenu(' + direction + ')');
    
    console.log('docHeight: (' + docHeight + ')');
    
    if (direction == 'left') {
      
      jQuery('#offcanvas').css({
        'height': docHeight + 'px' //Set the height of #offcavas to docheight.
      }).transition({
        x: '250px' //Moves off canvas nav block back to 0 (On screen).
      });
      
      jQuery('.wrapper').transition({ //Push the main content on x +250px //UPDATE THE VALUE
        x: '250px'
      }); 
      
    } else if(direction == 'right') {
    
      jQuery('#offcanvas').css({
        'height': docHeight + 'px' //Set the height of #offcavas to docheight.
      }).transition({
        x: '-' + menuWidth //Moves off canvas nav block back to 0 (On screen).
      });

      jQuery('.wrapper, .navigation_container').transition({ //Push the main content on x -menu width.
        x: '-' + menuWidth
      });
      
		} else if(direction == 'top') {
      
      jQuery('#offcanvas').transition({
        y: '+=' + menuHeight  //Moves off canvas nav block back to 0 (On screen).
      }, function() {
        console.log('#offcanvas moved relatively y+: '+ menuHeight + 'px');
      });
      
      jQuery('.wrapper, .navigation_container').transition({ //Push the main content down by the menu height
        y: menuHeight + 'px'
      }, function() {
        console.log('.wrapper, .navigation_container moved to y: '+ menuHeight + 'px');
      }); 
      
    }  else if(direction == 'bottom') {

      jQuery('#offcanvas').css('top', docHeight + 'px'); //Set the height of #offcavas to docheight. //DOES THIS WORK?

      jQuery('#offcanvas').transition({
        y: '-=' + menuHeight
      }, function() {
        console.log('#offcanvas moved relatively y-: '+ menuHeight);
      });
    
    }
    
  }

// Resize Watching function
jQuery(window).resize(function(direction) {

  //console.log('Window Re-sized...');

  if(jQuery(window).width() > 767) {
    //CloseMenu(direction);  
    jQuery('#offcanvas, .navigation_container, .wrapper').addClass('hidden').css({       //reset all the animation properties
      'transform': '',
      '-webkit-transform': '',
      'top': '',
      'left': '',
    });
      
  } else if(jQuery(window).width() < 767) {

    OpenMenu(direction);
    jQuery('#offcanvas').removeClass('hidden').css('left','');
    //console.log('IS VISIBLE');
}
})

});